// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountTab_grid__4jDX8 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-4);
  align-items: start;
}

.AccountTab_wide__7WSWN {
  grid-column: 1 / -1;
}

.AccountTab_heading__me2fl {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 var(--space-3);
}

.AccountTab_sub__1SipE {
  font-size: 0.9375rem;
  font-weight: 600;
  margin: var(--space-4) 0 var(--space-2);
}

.AccountTab_facts__pb4z6 {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-1) var(--space-3);
  margin: 0;
  font-size: 0.9375rem;
}

.AccountTab_facts__pb4z6 dt {
  color: var(--text-secondary);
}

.AccountTab_facts__pb4z6 dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.AccountTab_line__j9rHS {
  margin: 0 0 var(--space-2);
  font-size: 0.9375rem;
}

.AccountTab_help__ipGyX {
  font-size: 0.8125rem;
  color: var(--text-secondary);
  margin: var(--space-2) 0 0;
}

.AccountTab_list__EZ9hr {
  list-style: none;
  margin: 0;
  padding: 0;
}

.AccountTab_list__EZ9hr li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-2);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border-light);
  font-size: 0.9375rem;
  overflow-wrap: anywhere;
}

.AccountTab_row__ySCIk {
  display: flex;
  gap: var(--space-2);
  margin: var(--space-1) 0 var(--space-3);
}

.AccountTab_row__ySCIk .ui-input {
  flex: 1 1;
  min-width: 0;
}

.AccountTab_check__mgKjb {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: 0.9375rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/AccountTab.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,kCAAkC;EAClC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-4);\n  align-items: start;\n}\n\n.wide {\n  grid-column: 1 / -1;\n}\n\n.heading {\n  font-size: 1.05rem;\n  font-weight: 700;\n  margin: 0 0 var(--space-3);\n}\n\n.sub {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  margin: var(--space-4) 0 var(--space-2);\n}\n\n.facts {\n  display: grid;\n  grid-template-columns: max-content minmax(0, 1fr);\n  gap: var(--space-1) var(--space-3);\n  margin: 0;\n  font-size: 0.9375rem;\n}\n\n.facts dt {\n  color: var(--text-secondary);\n}\n\n.facts dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.line {\n  margin: 0 0 var(--space-2);\n  font-size: 0.9375rem;\n}\n\n.help {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  margin: var(--space-2) 0 0;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--border-light);\n  font-size: 0.9375rem;\n  overflow-wrap: anywhere;\n}\n\n.row {\n  display: flex;\n  gap: var(--space-2);\n  margin: var(--space-1) 0 var(--space-3);\n}\n\n.row :global(.ui-input) {\n  flex: 1;\n  min-width: 0;\n}\n\n.check {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 0.9375rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `AccountTab_grid__4jDX8`,
	"wide": `AccountTab_wide__7WSWN`,
	"heading": `AccountTab_heading__me2fl`,
	"sub": `AccountTab_sub__1SipE`,
	"facts": `AccountTab_facts__pb4z6`,
	"line": `AccountTab_line__j9rHS`,
	"help": `AccountTab_help__ipGyX`,
	"list": `AccountTab_list__EZ9hr`,
	"row": `AccountTab_row__ySCIk`,
	"check": `AccountTab_check__mgKjb`
};
export default ___CSS_LOADER_EXPORT___;
